import classNames from 'classnames';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import React, { useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { FaPencil } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { mask, unMask } from 'remask';
import { Api } from '../../../services/api';

function UpdateAssociate({ close, reload, associateInfo }) {
  const [associateName, setAssociateName] = useState(associateInfo.associado_nome);
  const [associateEmail, setAssociateEmail] = useState(associateInfo.associado_email);
  const [associateDoc, setAssociateDoc] = useState(mask(associateInfo.associado_documento, ["999.999.999-99", "99.999.999/9999-99"]));
  const [associateStatus, setAssociateStatus] = useState(associateInfo.associado_status);
  const [showConfirm, setShowConfirm] = useState(false);

  function handleCreateAssociate(event) {
    event.preventDefault();
    if (associateDoc.length === 14 || associateDoc.length === 18)
      setShowConfirm(true);
    else
      toast.error('Insira um CPF/CNPJ válido');
  }

  const options =[
    { name: 'Ativo', value: true },
    { name: 'Inativo', value: false },
  ]

  // associado_nome: 
  // associado_email: 
  // associado_documento: 
  // password:
  // associado_status:

  const UpdateAssociate = async () => {
    const updateData = {
      associado_nome: associateName,
      associado_email: associateEmail,
      associado_documento: unMask(associateDoc, ['999.999.999-99', '99.999.999/9999-99']),
      associado_status: associateStatus,
    }

    try {
      await Api.put(`/associados/${associateInfo.associado_id}`, updateData);
      toast.success('Usuário atualizado com sucesso!')
      close();
      reload();
    } catch (error) {
      console.log(error);
      toast.error('Erro de conexão');
      close();
    }
  }

  function formatStatus(e) {
    let type = "bg-slate-300 text-slate-700";;
    let value = "INATIVO"
    if (e === true) {
      type = "bg-emerald-300 text-emerald-700";;
      value = "ATIVO"
    }
    return (
            <div className="flex justify-center items-center ">
              <span className={classNames(
                'text-nowrap py-1 px-2 justify-center flex w-auto',
                type
              )}
              >
                <p className="uppercase text-sm font-bold">
                  {value}
                </p>
              </span>
            </div>)
  }

  const footer = (
    <div className="w-full flex justify-between">
      <div className="grid w-1/3" >
        <Button
          severity='success'
          label="Sim"
          icon={<FaCheck/>}
          onClick={() => { UpdateAssociate() }} />
      </div>
      <div className="grid w-1/3" >
        <Button
          severity='danger'
          label="Não"
          icon={<FaTimes/>}
          onClick={() => { setShowConfirm(false) }} />
      </div>
    </div>)

  return (
    <>
      <Dialog
        header="Deseja atualizar os dados do usuário?"
        onHide={() => setShowConfirm(false)}
        visible={showConfirm}
        pt={{
          root: 'w-screen md:w-[50vw] lg:w-[30vw] h-auto',
          headerTitle: 'font-bold text-xl w-full text-center',
        }}
        footer={footer}
      >
        <div className="flex p-3 md:justify-between md:text-left text-center">
          <div className="grid items-start w-full md:w-7/12 mt-4">
            <h5><b>Nome: </b>{associateName}</h5>
            <h5><b>Email: </b>{associateEmail}</h5>
            <h5><b>Documento: </b>{associateDoc}</h5>
            <h5><b>Status: </b>{formatStatus(associateStatus)}</h5>
          </div>
          <div className="w-full md:w-1/3">
            <FaPencil className='text-green-600 w-full h-auto'/>
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Atualizar usuário"
        onHide={() => close()}
        pt={{
          root: 'w-screen md:w-[50vw] lg:w-[20vw] h-auto',
          headerTitle: 'font-bold text-xl w-full text-center',
        }}
        visible
      >
        <div className="grid">
          <form onSubmit={(e) => handleCreateAssociate(e)}>
            <div className="grid w-full gap-4">
              <div className="w-full text-left grid">
                <p htmlFor="associate_name" className=''>Nome do Usuário</p>
                <InputText
                  id="associate_name"
                  placeholder="ex: Everton Oliveira"
                  value={associateName}
                  onChange={(e) => setAssociateName(e.target.value)}
                  type="text"
                  required
                ></InputText>
              </div>

              <div className="w-full text-left grid">
                <p htmlFor="associate_email" className=''>E-mail do Usuário</p>
                <InputText
                  id="associate_email"
                  placeholder="ex: example@hotmail.com"
                  value={associateEmail}
                  onChange={(e) => setAssociateEmail(e.target.value)}
                  type="email"
                  required
                ></InputText>
              </div>

              <div className="w-full text-left grid">
                <p htmlFor="associate_document" className=''>Documento do Usuário</p>
                <InputText
                  id="associate_document"
                  placeholder="ex: 999.999.999-99"
                  value={associateDoc}
                  onChange={({ target }) =>
                    setAssociateDoc(
                      mask(unMask(target.value), [
                        '999.999.999-99',
                        '99.999.999/9999-99'
                      ])
                    )
                  }
                  type="text"
                  required
                ></InputText>
              </div>

              <div className="w-full flex justify-between">
                <h6 className="mt-2">Status</h6>
                <SelectButton
                  value={associateStatus}
                  onChange={(e) => setAssociateStatus(e.value)}
                  options={options}
                  optionLabel="name"
                />
                {/* <ToggleButton
                  id="status"
                  pt={ToggleButtonPague}
                  checked={associateStatus}
                  onLabel="Ativo"
                  offLabel="Inativo"
                  onChange={(e) => setAssociateStatus(e.value)} /> */}
              </div>

              <div className="w-full grid mt-3">
                <Button
                  label="Enviar"
                  type="submit"
                  severity='success'
                />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </>
  )
}

export default UpdateAssociate